// 개인정보 수집·이용 동의 약관. 한국어 원문을 기준으로 하며, 영어는 번역본이다.
const PRIVACY_TERMS = {
  ko: {
    intro:
      '대한버추얼스포츠협회(이하 "협회")는 「개인정보 보호법」에 따라 대회 참가 신청과 관련하여 아래와 같이 개인정보를 수집·이용합니다.',
    sections: [
      {
        title: '1. 개인정보 수집·이용 목적',
        body: '대한버추얼스포츠협회는 대회 참가 신청 접수, 참가자 확인, 대진표 작성·운영, 대회 관련 안내(일정·장소·결과 등), 참가 관련 문의 응대 및 분쟁 처리를 위해 개인정보를 수집·이용합니다.',
      },
      {
        title: '2. 수집하는 개인정보 항목',
        body: '필수항목: 소속 협회(학교명), 도장명(팀명), 참가자 성명, 참가자 연락처, 보호자 연락처, 생년월일, 성별, 신장, 신청 대회 정보',
      },
      {
        title: '3. 개인정보 보유·이용 기간',
        body: '수집된 개인정보는 대회 종료 후 관련 법령에 따른 보존 기간이 경과할 때까지 보관하며, 목적 달성 후에는 지체 없이 파기합니다. 다만, 관계 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관합니다.',
      },
      {
        title: '4. 개인정보의 제3자 제공',
        body: '협회는 원칙적으로 참가자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 대회 운영·중계·기록 등 대회 목적 달성을 위해 필요한 범위에서 협력 업체에 제공될 수 있으며, 이 경우 사전에 안내합니다.',
      },
      {
        title: '5. 동의 거부 권리 및 불이익',
        body: '귀하는 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 다만, 필수 항목에 대한 동의를 거부하실 경우 대회 참가 신청이 제한될 수 있습니다.',
      },
      {
        title: '6. 개인정보 보호 책임자',
        body: '개인정보 처리와 관련한 문의는 대한버추얼스포츠협회 대회 운영 담당자에게 연락해 주시기 바랍니다.',
      },
    ],
    agreementLabel: '위 개인정보 수집·이용 내용을 확인하였으며, 이에 동의합니다. (필수)',
  },
  en: {
    intro:
      'In accordance with the Personal Information Protection Act, the Korea Virtual Sports Association (the "Association") collects and uses personal information in connection with tournament registration as described below.',
    sections: [
      {
        title: '1. Purpose of collection and use',
        body: 'The Korea Virtual Sports Association collects and uses personal information to receive tournament registrations, verify participants, prepare and operate brackets, provide tournament-related notices (schedule, venue, results, etc.), respond to registration inquiries, and handle disputes.',
      },
      {
        title: '2. Personal information collected',
        body: 'Required items: association (school name), gym name (team name), participant name, participant phone number, parent/guardian phone number, date of birth, gender, height, and details of the tournament applied for.',
      },
      {
        title: '3. Retention and use period',
        body: 'Collected personal information is retained after the tournament ends until the retention period required by applicable laws has expired, and is destroyed without delay once its purpose has been fulfilled. However, where retention is required by relevant laws, it is kept for the period so required.',
      },
      {
        title: '4. Provision to third parties',
        body: "As a rule, the Association does not provide participants' personal information to third parties. However, it may be provided to partner companies to the extent necessary to achieve the purposes of the tournament, such as tournament operation, broadcasting, and record-keeping. In such cases, you will be notified in advance.",
      },
      {
        title: '5. Right to refuse consent and consequences',
        body: 'You have the right to refuse consent to the collection and use of personal information. However, if you refuse consent for the required items, your tournament registration may be restricted.',
      },
      {
        title: '6. Privacy officer',
        body: 'For inquiries regarding the processing of personal information, please contact the tournament operations staff of the Korea Virtual Sports Association.',
      },
    ],
    agreementLabel:
      'I have read the above information on the collection and use of personal information and agree to it. (Required)',
  },
};

/** 언어별 약관 { intro, sections: [{ title, body }], agreementLabel }. 없는 언어는 한국어 원문 */
export function getPrivacyTerms(lang) {
  return PRIVACY_TERMS[lang] ?? PRIVACY_TERMS.ko;
}
